<template>
  <Menu as="div" class="relative inline-block text-left">
    <div>
      <MenuButton v-if="btnText" :class="cls">{{ btnText }}
        <ChevronDownIcon class="-mr-1 ml-2 h-5 w-5"/>
      </MenuButton>
      <MenuButton :class="btnClass" v-else>
        <slot name="button">
          <DotsVerticalIcon class="h-5 w-5" aria-hidden="true"/>
        </slot>
      </MenuButton>
    </div>

    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <MenuItems
          class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-30">
        <ul class="py-1">
          <slot>Empty list</slot>
        </ul>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import {Menu, MenuButton, MenuItems} from '@headlessui/vue'
import {DotsVerticalIcon, ChevronDownIcon} from '@heroicons/vue/solid'

export default {
  components: {
    Menu,
    MenuButton,
    MenuItems,
    DotsVerticalIcon,
    ChevronDownIcon
  },
  props: {
    btnClass: {
      default: 'rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-primary-500'
    },
    btnText: {
      default: ''
    },
    color: {
      default: 'white'
    },
    btnSize: {
      default: 'sm'
    }
  },
  computed: {
    cls() {
      return {
        'inline-flex justify-center w-full rounded-md border shadow-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2': true,
        'border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-offset-gray-100 focus:ring-primary-500': this.color === 'white',
        'border-transparent bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500': this.color === 'primary',

        'px-2.5 py-1.5 text-xs': this.btnSize === 'xs',
        'px-2.5 py-1.5 text-sm': this.btnSize === 'sm-',
        'px-3 py-2 text-sm': this.btnSize === 'sm',
        'px-4 py-2 text-sm': this.btnSize === 'md',
        'px-4 py-2 text-base': this.btnSize === 'lg',
        'px-6 py-3 text-base': this.btnSize === 'xl',
      }
    }
  }
}
</script>